module.exports = __webpack_public_path__ + "static/media/990840.cbd989cd.png";